import {DropZone} from "@/components/ui/forms/DropZone";

import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const UploadImagePopup = ({setPhotoFile}) => {
  const {closePopup} = usePopup();
  const {t} = useTranslation();

  const uploadFile = (file) => {
    if (file) {
      setPhotoFile(file);
      closePopup();
    } else {
      console.log("File is undefined!");
    }
  };

  return (
    <div className={styles.upload}>
      <H3>{t("popup.upload_image.title")}</H3>

      <div className={styles.uploadDesc}>
        <RootDesc>
          <span>{t("popup.upload_image.subtitle")}</span>
        </RootDesc>
      </div>

      <DropZone
        maxFiles={1}
        accept={{"image/*": [".png", ".jpg"]}}
        onUpload={uploadFile}
        size={5 * 1024 * 1024}
        type={"jpg, png"}
      />
    </div>
  );
};
